import { GetterTree } from 'vuex';
import { RootState } from '@/store/types';
import { PageState } from '@/store/currentPage/types';

export const getters: GetterTree<PageState, RootState> = {
  currentPage(state) {
    return state.currentPage;
  }
};
